export function shouldTrackSettingsModalOpen(previousVisible: boolean, nextVisible: boolean): boolean {
  return !previousVisible && nextVisible;
}
